import React from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/context/AuthContext';
import AuthCallback from '@/pages/AuthCallback';
import Landing from '@/pages/Landing';
import EnterPage from '@/pages/Enter';
import LoginPage from '@/pages/Login';
import SignupPage from '@/pages/Signup';
import InvitePage from '@/pages/Invite';
import ContactPage from '@/pages/Contact';
import ClientPortal from '@/pages/portal/ClientPortal';
import AdminPortal from '@/pages/admin/AdminPortal';
import AdminLogin from '@/pages/admin/AdminLogin';
import GoogleCallback from '@/pages/GoogleCallback';
import '@/App.css';

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/enter" element={<EnterPage />} />
      <Route path="/auth/google" element={<GoogleCallback />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/invite" element={<InvitePage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/portal/*" element={<ClientPortal />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/*" element={<AdminPortal />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
